import { useEffect } from "react";
import { initBackClick } from "../../utils/backClickLib";

const BackClick = ({
    mode = "iframe",
    isDesktop,
    adIds,
    block_id,
    domain,
    showFullscreen = false,
    maxRedirectsCount,
}) => {
    const resolvedBlockId =
        block_id || (typeof adIds === "object" && adIds !== null ? (isDesktop ? adIds.pc : adIds.mob) : adIds);

    if (!resolvedBlockId) {
        return null;
    }

    useEffect(() => {
        let href = `https://${domain}/widget.html?block_id=${resolvedBlockId}`;
        if (showFullscreen) href += `&show_fullscreen=${showFullscreen}`;

        const config = { mode, href, frequency: 1 };

        if (maxRedirectsCount !== undefined) {
            config.maxRedirects = maxRedirectsCount;
        }

        const destroy = initBackClick(config);

        let observer;
        if (mode === "iframe") {
            observer = new MutationObserver((mutations) => {
                for (const mutation of mutations) {
                    if (mutation.removedNodes.length) {
                        for (const node of mutation.removedNodes) {
                            if (node.id === "smi") {
                                observer.disconnect();
                                window.location.reload();
                                return;
                            }
                        }
                    }
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }

        return () => {
            destroy();
            if (observer) observer.disconnect();
        };
    }, [resolvedBlockId, mode, domain, showFullscreen, maxRedirectsCount]);

    return null;
};

export default BackClick;
